<template>
  <page-outline :title="$t('administration.user_details')">
    <template slot="pageContent">
      <b-row class="pb-3 mx-0 no-gutters">
        <back-button class="btnFilter_2 mr-2" :returnUrl="returnUrl"></back-button>
      </b-row>
      <hr class="mx-auto" />
      <spinner v-if="activateSpinner"></spinner>
      <template v-else-if="User">
        <div class="title-label-blue w-200px pt-3">{{$t('administration.user_info')}}</div>
        <table class="table">
          <tbody>
              <tr>
                <th class="text-center w-50">
                  {{ $t('administration.identifier') }}
                </th>
                <td class="text-center">
                  {{ User.Login }}
                </td>
              </tr>
              <tr v-if="User.Name">
                <th class="text-center w-50">
                  {{ $t('administration.user_name') }}
                </th>
                <td class="text-center">
                  {{ User.Name }}
                </td>
              </tr>
              <tr>
                <th class="text-center w-50">
                  {{ $t('administration.active') }}
                </th>
                <td class="text-center w-50">
                  <i v-if="User.Active == 0" class="fa-duotone fa-xmark btn btn-icon btn-icon-red p-0 min-h-auto"></i>
                  <i v-if="User.Active == 2" class="fa-duotone fa-check btn btn-icon btn-icon-green p-0 min-h-auto"></i>
                  <i v-if="User.Active == 1" class="fa-duotone fa-warning btn btn-icon btn-icon-orange p-0 min-h-auto"></i>
                </td>
              </tr>
          </tbody>
        </table>
        <br>
        <hr class="mx-auto" />
        <br>
        <div class="title-label-blue w-200px pt-3">{{$t('administration.user_auth')}}</div>
        <table class="table table-striped" v-if="User.Rights && User.Rights.length">
          <tbody>
            <tr>
              <th class="text-center w-50">
                {{ $t('administration.company_name') }}
              </th>
              <th class="text-center w-50">
                {{ $t('administration.profile') }}
              </th>
            </tr>
            <tr  v-for="right in User.Rights" :key="right.IdAccount + '-' + right.IdRightProfile">
              <td @click="seeCompanyDetail(right.IdAccount)" class="cursor text-center w-50">
                {{ right.AccountName }}
              </td>
              <td @click="seeRoleDetail(right.IdRightProfile, right.IdAccount)" class="cursor text-center w-50">
                {{ hasProfileTrad(right.RightsProfileName) }}
              </td>
            </tr>
          </tbody>
        </table>
        <b-col v-else class="mt-3">
          {{ $t('administration.no_profile') }}
        </b-col>
        <br>
        <b-row class="min-w-100 align-items-center">
      		<b-col class="d-flex justify-content-end">
      			<template >
      				<b-button
                v-if="canUserEdit"
      				  class="back-button btnFilter_2 mr-2"
      				  @click="activateEdit(User.IdUser)">
      				  <i class="fa-light fa-pencil"></i>  {{ $t('administration.user_edit') }}
      				</b-button>
      				<b-button
                v-if="canUserDelete"
      				  class="back-button btnFilter_2"
      				  @click="activateDelete(User.IdUser)"
      				>
      				  <span><i class="fa-light fa-trash"></i> {{ $t('administration.user_delete') }}</span>
      				</b-button>
      			</template>
      		</b-col>
        </b-row>
      </template>
    </template>
  </page-outline>
</template>

<script>
import moment from 'moment'
import {errorMessageAlert} from '@/helpers/alert'
import PageOutline from '@/components/common/PageOutline.vue'
import {loadPage, reloadPage} from '@/helpers/routing'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'

export default {
  name: 'DetailUserCompany',
  components: {
    'page-outline': PageOutline,
    'back-button': backButton,
    'spinner': Spinner
  },
  computed: {
    buttonsListStyle () {
      return (!this.isSmartphoneOS) ? 'border: 1px solid #aaa;' : ''
    },
    canUserDelete () {
      return (this.$engine.rights.rightIs('usercompany_supprimer', true) || this.$engine.rights.rightIs('usercompany_supprimer_admin', true)) &&
        !this.User.Rights.filter(elem => elem.RightsProfileName === 'Super admin').length
    },
    canUserEdit () {
      console.log(this.$engine.rights)
      return (this.$engine.rights.rightIs('usercompany_editer', true) || this.$engine.rights.rightIs('usercompany_editer_admin', true)) &&
        !this.User.Rights.filter(elem => elem.RightsProfileName === 'Super admin').length
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    listTitle () {
      return 'Details de l\'utilisateur'
    },
    UserRightsFiltered () {
      let currentNorm = this.$engine.user.getUserNorm()
      return this.User.Rights.filter(elem => {
        return (elem.RightsProfileName.includes('_SRTP') && currentNorm === '1') ||
        (elem.RightsProfileName.includes('_HRTP') && currentNorm === '2') ||
        (elem.RightsProfileName.includes('_PSD2') && currentNorm === '3') ||
        this.$engine.rights.rightIs('super_admin', true)
      })
    }
  },
  props: ['idUserAcc', 'idCompany'],
  data () {
    return {
      activateSpinner: false,
      returnUrl: '',
      User: {}
    }
  },
  created () {
    this.defineReturnURL()
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Details de l\'utilisateur',
      // returnUrl: ''
    })

    this.$engine.settings.set({msgDirection: this.direction})
    this.getUser()
    this.$f7.initPullToRefresh()
    this.pageCounter = 0

    this.filterTypeGet = this.filterType
    this.$bus.$emit('right-panel-set-feature', 'filter-messages')
  },
  methods: {
    defineReturnURL() {
      if (this.idCompany === 'undefined') {
        this.returnUrl =  '/usercompany/'
      } else {
        this.returnUrl = '/detail/' + this.idCompany
      }
    },
    getProfiles () {
      let that = this
      let idCompanies = []
      if (this.User?.Rights?.length) {
        idCompanies = _.uniqBy(this.User.Rights, 'IdAccount').map(elem => elem.IdAccount).join(',')
      }
      this.$engine.rights.getAllProfiles(idCompanies)
      .then(resp => {
        that.$engine.company.profiles = resp.profiles.map(profile => {
          return {
            id_rights_profile: profile.idProfile,
            libelle: profile.libelleProfile
          }
        })
      })
      .catch(err => {
        return err
      })
    },
    getUser () {
      this.pageCounter = 0
      this.activateSpinner = true
      let that = this
      that.$engine.usercompany.idUserAcc = this.idUserAcc
      this.UsersList = []
      let filterConditions = that.$engine.usercompany.getConditionObject()
      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = this.sortDirection
      that.$engine.usercompany.getUser(
        this.idUserAcc,
        10,
        1,
        filterConditions
      ).then(resp => {
        let requests = {}
        if (resp.data && resp.data.users && resp.data.users.length) {
          let userCompany = resp.data.users[0]
          that.User = userCompany
          that.getProfiles()
          this.$f7.pullToRefreshDone()
          this.$bus.$emit('refresh-cache-paging-template', this.paginationObject)
        }
        this.activateSpinner = false
      }).catch(error => {
        this.activateSpinner = false
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    activateEdit (ressource) {
      let that = this
      let idCompany = this.User.Rights?.length ? this.User.Rights[0].IdAccount : that.idCompany
      loadPage(that, {url: '/editusercompany/' + ressource + '/' + idCompany})
    },
    activateDelete (ressource) {
      let that = this
      this.$f7.modal({
        title: this.$i18n.t('administration.del_user_qt'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              that.$engine.usercompany.deleteUser(ressource)
              .then(resp => {
                that.$f7.alert('', that.$t('administration.del_user'))
                reloadPage(that, {url: '/detail/' + that.idCompany})
              }).catch(e => {
                errorMessageAlert(e, that)
                that.$f7.modal({
                  title: that.$i18n.t('administration.del_error'),
                  buttons: [
                    {
                      text: 'OK',
                      onClick: function () {
                        return
                      }
                    }
                  ]
                })
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    hasProfileTrad (profileName) {
      let trad = this.$i18n.t('rights.db_profiles.' + profileName)
      if (trad === ('rights.db_profiles.' + profileName)) {
        return profileName
      }
      return trad
    },
    seeRoleDetail (ressource, id) {
      let that = this
      loadPage(that, {url: '/detailprofilcompany/' + ressource + '/' + id})
    },
    seeCompanyDetail (ressource) {
      let that = this
      loadPage(that, {url: '/detail/' + ressource})
    },
  }
}
</script>
